#import "../fragments/reaction-fragment.graphql"

mutation CreateReaction($input: ReactionCreateInput!) {
    reactionCreate(input: $input) {
        reaction {
            ...ReactionFragment
        }
    }
}
